/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */

import React from "react";
import {Divider, IconButton, Stack, Typography} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Link, useParams} from "react-router-dom";
import SubscriptionForm from "./SubscriptionForm";
import {useQuery} from "urql";
import {EventSubscriptionQuery, EventSubscriptionQueryVars, EventSubscriptionResponse} from "../../graphql/queries/event-subscriptions";
import {useSelector} from "react-redux";
import {State} from "../../state/store";
import HeroMessage from "../../components/HeroMessage";
import LoadingHero from "../../components/LoadingHero";

export default function EditSubscription() {

	const user = useSelector((s:State) => s.user);
	const { id } = useParams<{id?: string}>();

	const [eventSubscriptionResult] = useQuery<EventSubscriptionResponse, EventSubscriptionQueryVars>({
		query: EventSubscriptionQuery,
		variables: {
			id: Number(id)
		},
		pause: isNaN(Number(id)) || !user?.id
	});

	const eventSubscription = eventSubscriptionResult.data?.eventSubscription;
	const editDisabled = eventSubscription?.createdBy !== user?.id;

	return (
		<Stack spacing={1} sx={{ p: 1 }}>
			<Stack direction={"row"} alignItems={"center"}>
				<IconButton size={"large"} to={"/notifications/events"} component={Link}>
					<ArrowBackIcon />
				</IconButton>
				<Stack>
					<Typography gutterBottom  variant="h4" sx={{ mb: 0, ml: 1 }}>
						Edit Event Notification #{id}
					</Typography>
				</Stack>
			</Stack>
			<Divider />
			{eventSubscriptionResult.error &&
				<HeroMessage
					p={4}
					title={"Request Error"}
					titleTypographyProps={{ variant: "h6" }}
					message={eventSubscriptionResult.error.message}
				/>
			}
			{eventSubscriptionResult.fetching && <LoadingHero />}
			{!eventSubscriptionResult.error && !eventSubscriptionResult.fetching && eventSubscription &&
			<SubscriptionForm
				id={Number(id)}
				config={eventSubscription.config || { types: [] }}
				disabled={editDisabled}
			/>}
		</Stack>
	);

}